import { InjectionToken } from '@angular/core';

export interface LocalStorageConfig {
  namespace?: string;
  version?: string;
  preserveOnVersionChange?: string[];
  storage?: 'local' | 'session';
}

export const LOCAL_STORAGE_CONFIG = new InjectionToken<LocalStorageConfig>(
  'LOCAL_STORAGE_CONFIG'
);
